function toggleContent(contentId, icon) {
  const content = document.getElementById(contentId);

  if (content.style.height === "0px" || content.style.height === "") {
    content.style.display = "flex"; // Show content
    content.style.height = content.scrollHeight + "px"; // Expand content
    icon.classList.remove("fa-plus");
    icon.classList.add("fa-chevron-up");
    icon.parentElement.style.backgroundColor = "#143c7d";
    icon.style.color = "#fff"; // Set text color to white
  } else {
    content.style.display = "none"; // Show content
    content.style.height = "auto"; // Collapse content
    window.requestAnimationFrame(function () {
      content.style.height = "0px"; // Set to 0 to collapse
    });
    icon.classList.remove("fa-chevron-up");
    icon.classList.add("fa-plus");
    icon.parentElement.style.backgroundColor = "#f3f4f5";
    icon.style.color = "#000000"; // Reset text color
  }
}

// Add event listeners to all toggle icons
document.querySelectorAll(".faq-toggle-icon").forEach((iconElement) => {
  iconElement.addEventListener("click", function () {
    const contentId = iconElement.getAttribute("data-content-id");
    toggleContent(contentId, this);
  });
});
